
export default {
  namespaced: true,
  state: {
    params: null
  },
  actions: {
    /**
     * @description 设置路由跳转传递数据
     * @param {Object} context
     * @param {Boolean} params 数据对象
     */
    set({ state, dispatch },{path, params}) {
      return new Promise(async resolve => {
        // store 赋值
        state.params = params
        // 持久化
        await dispatch('d2admin/db/set', {
          dbName: 'routerParams',
          path: path,
          value: params,
          user: true
        }, { root: true })
        resolve()
      })
    },
    /**
     * 从数据库读取路由跳转传递数据
     * @param {Object} context
     */
    load({ state, dispatch },path) {
      return new Promise(async resolve => {
        state.params = await dispatch('d2admin/db/get', {
          dbName: 'routerParams',
          path: path,
          defaultValue: null,
          user: true
        }, { root: true })
        resolve( state.params)
      })
    }
  }
}
